export enum QueueStrategy {
    RINGALL = 'ringall',
    LEASTRECENT = 'leastrecent',
    FEWESTCALLS = 'fewestcalls',
    RANDOM = 'random',
    RRMEMORY = 'rrmemory',
    RRORDERED = 'rrordered',
}
